export default "__VITE_ASSET__c8769a78__"